import { OperatorIdentity } from '@/infrastructure/OperatorIdentity';
import { unknownMentions, useMentionRoster } from './mentionRoster';

/** One wording for every composer, so the four screens never fork it. */
export const unknownMentionNotice = (names: string[]): string =>
  `${names.map((name) => `@${name}`).join(', ')} ${names.length === 1 ? 'is not a name' : 'are not names'} the admin knows, so the mention may notify no one. Check the spelling before posting.`;

export interface MentionWarningProps {
  /** The draft as typed; the notice follows it keystroke by keystroke. */
  text: string;
  /** The @name still being typed with the suggestion list open: not a misspelling yet, so not warned about. */
  typing?: string | null | undefined;
}

/**
 * Flags a typed @name the admin has never seen (SSD-7435): the Slack notice goes out whatever is typed, so a
 * misspelt handle reaches nobody and nobody knows. It only warns; the operator may still post.
 */
export function MentionWarning({ text, typing }: MentionWarningProps) {
  const known = useMentionRoster();
  const unknown = unknownMentions(text, known, OperatorIdentity.current()).filter((handle) => handle !== typing);
  if (unknown.length === 0) {
    return null;
  }
  return (
    <div role="status" data-testid="mention-warning" style={{ color: '#b45309', fontSize: 12, marginTop: 4 }}>
      {unknownMentionNotice(unknown)}
    </div>
  );
}
